import { CrownBadge } from 'components/ProFeatureLabel'
import QuestionActions from 'components/QuestionActions'
import { TooltipLabel } from 'components/TooltipLabel'
import useAxios from 'hooks/useAxios'
import useModal from 'hooks/useModal'
import QuesitonVisibility from 'organisms/QuesitonVisibility'
import QuestionConditionModalContainer from 'organisms/QuestionConditionModal/container'
import { surveySettingContext } from 'pages/SurveySettings/context'
import * as R from 'ramda'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Accordion, Form, Segment } from 'semantic-ui-react'
import { prepareMainQuestionAndFollowUpQuestion } from './utils'

export default function QuestionConditionLogic({
  questionList,
  question,
  surveyToken,
  isPrimary,
  setFieldValue,
  questionIndex,
  questionIdWithVisibilityRuleError,
}) {
  const firstTimeRender = useRef(true)
  const { open, close, isOpen } = useModal()
  const [activeAccordion, setActiveAccordion] = useState(false)
  const { deletedVisibility, setContext } = useContext(surveySettingContext)

  function handleDeleteVisibility(visibility) {
    const newDeletedVisibility = deletedVisibility
    newDeletedVisibility.push(visibility)

    // add deleted visibility on surveySettingContext
    setContext({
      deletedVisibility: newDeletedVisibility,
    })
    // Update visibility on survey-builder forkmilk state
    setFieldValue(`questions[${questionIndex}].visibilityCondition`, [])
  }

  const handleUpdateVisibility = (newVisibility) => {
    setFieldValue(
      `questions[${questionIndex}].visibilityCondition`,
      R.isEmpty(newVisibility) ? [] : [newVisibility]
    )
  }

  useEffect(() => {
    const shouldOpenConditionalLogicAccordion =
      question.displayFollowUpQuestion || !R.isEmpty(question.visibilityCondition)
    if (firstTimeRender.current && shouldOpenConditionalLogicAccordion) {
      setActiveAccordion(true)
      firstTimeRender.current = false
    }
  }, [question])

  function convertVisibilityArrayToObject(visibility) {
    if (visibility && !R.isEmpty(visibility)) {
      return visibility[0]
    } else {
      return {}
    }
  }

  const { data: enabledVisibilityCondition } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature: 'visibility_condition' },
  })
  const isEnabledVisibilityCondition = R.path(['enabled'], enabledVisibilityCondition)

  if (isPrimary) {
    return (
      <>
        <Form.Field>
          <label>
            Question actions
            <TooltipLabel
              className="tooltip"
              descriptionTitle="Question actions"
              descriptionContent={
                <p>
                  Question actions are conditional logic settings that allow you to ask contextual
                  follow-up questions.
                </p>
              }
              learnMoreLink="https://help.simplesat.io/en/articles/2776705-survey-questions#h_59d547c946"
            />
          </label>
          <QuestionActions
            questionAction={question.questionCondition}
            isPrimary
            open={open}
            isLogicButtonDisabled={
              !R.prop('id', question) || R.any(R.propEq('id', null), question.choices)
            }
          />
        </Form.Field>

        {isOpen === true && (
          <QuestionConditionModalContainer
            isOpen={open}
            close={close}
            questionId={question.id}
            surveyToken={surveyToken}
            isPrimary={false}
          />
        )}
      </>
    )
  }

  return (
    <>
      <Accordion>
        <Accordion.Title active={activeAccordion}>
          <Form.Field
            data-testid="conditional-logic-header"
            className="flex flex-row items-baseline"
            onClick={() => setActiveAccordion(!activeAccordion)}
          >
            <i className="fas fa-caret-down icon" />
            <label className="cursor-pointer">Conditional logic</label>
          </Form.Field>
        </Accordion.Title>
        <Accordion.Content active={activeAccordion}>
          <Segment>
            <Form.Field>
              <label>
                Question actions
                <TooltipLabel
                  className="tooltip"
                  descriptionTitle="Question actions"
                  descriptionContent={
                    <p>
                      Question actions are conditional logic settings that allow you to ask
                      contextual follow-up questions.
                    </p>
                  }
                  learnMoreLink="https://help.simplesat.io/en/articles/2776705-conditional-logic#h_59d547c946"
                />
              </label>
              <QuestionActions
                questionAction={question.questionCondition}
                isPrimary={false}
                open={open}
                isLogicButtonDisabled={
                  !R.prop('id', question) || R.any(R.propEq('id', null), question.choices)
                }
              />
            </Form.Field>
            {!isPrimary && (
              <Form.Field>
                <label>
                  Visibility
                  <TooltipLabel
                    className="tooltip"
                    icon={isEnabledVisibilityCondition === false ? <CrownBadge /> : null}
                    descriptionTitle={'Visibility'}
                    descriptionContent={
                      <>
                        <p>
                          Use visibility rules to show this question only when certain conditions
                          are met—for example, if someone gives a positive rating to a previous
                          question.
                        </p>
                        {isEnabledVisibilityCondition === false && (
                          <p>
                            Visibility logic is available on a higher plan. Upgrade to unlock this
                            feature.
                          </p>
                        )}
                      </>
                    }
                    learnMoreLink="https://help.simplesat.io/en/articles/2776705-conditional-logic#h_f3463c02d6"
                    showGotoBillingPage={isEnabledVisibilityCondition === false}
                    isUpgradeButton={true}
                  />
                </label>
                <QuesitonVisibility
                  question={question}
                  questionList={prepareMainQuestionAndFollowUpQuestion(questionList)}
                  visibilityCondition={convertVisibilityArrayToObject(question.visibilityCondition)}
                  handleUpdateVisibility={handleUpdateVisibility}
                  handleDeleteVisibility={handleDeleteVisibility}
                  questionIdWithVisibilityRuleError={questionIdWithVisibilityRuleError}
                  isLogicButtonDisabled={!isEnabledVisibilityCondition}
                />
              </Form.Field>
            )}
          </Segment>
        </Accordion.Content>
      </Accordion>

      {isOpen === true && (
        <QuestionConditionModalContainer
          isOpen={open}
          close={close}
          questionId={question.id}
          surveyToken={surveyToken}
          isPrimary={false}
        />
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/QuestionConditionalLogic/index.js